import { motion } from "framer-motion";

export const AibaLogo = ({ className = "", size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="aibaGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#2563EB" />
        <stop offset="100%" stopColor="#0047AB" />
      </linearGradient>
    </defs>
    <path d="M32 6 L58 54 H42 L32 32 L22 54 H6 Z" fill="url(#aibaGrad)" />
    <path d="M32 26 L40 42 H24 Z" fill="#0F172A" />
  </svg>
);

export const HoloTriangle = () => (
  <div className="relative flex items-center justify-center" aria-hidden="true">
    <motion.svg
      width="420"
      height="420"
      viewBox="0 0 200 200"
      className="drop-shadow-[0_0_45px_rgba(37,99,235,0.45)]"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
    >
      <defs>
        <linearGradient id="holo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#0047AB" />
        </linearGradient>
      </defs>
      {[0, 1, 2].map((i) => (
        <motion.polygon
          key={i}
          points="100,22 168,150 32,150"
          fill="none"
          stroke="url(#holo)"
          strokeWidth={0.7 + i * 0.4}
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 0.5 - i * 0.12 }}
          transition={{ duration: 2.4, delay: 0.3 + i * 0.2, ease: "easeInOut" }}
          style={{ transformOrigin: "center", transform: `scale(${1 + i * 0.14})` }}
        />
      ))}
      <motion.polygon
        points="100,58 138,132 62,132"
        fill="url(#holo)"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 0.9, scale: 1 }}
        transition={{ duration: 1.2, delay: 1 }}
        style={{ transformOrigin: "center" }}
      />
      <polygon points="100,86 116,118 84,118" fill="#0F172A" />
    </motion.svg>
    <motion.div
      className="absolute inset-0 m-auto h-[520px] w-[520px] rounded-full border border-blue-400/10 animate-spin-slow"
      style={{ borderTopColor: "rgba(37,99,235,0.4)" }}
    />
  </div>
);
